import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDebounce } from '../../../utils/custom-hooks';
import SearchBar from './search-bar';
import Button from '../button/button';

const Search = props => {
  const { onSearch, debounce, placeholder, styleType } = props;
  const [searchTerm, setSearchTerm] = useState('');
  const debouncedSearchTerm = useDebounce(searchTerm, 600);

  useEffect(() => {
    if (debounce) {
      onSearch(debouncedSearchTerm);
    }
  }, [debouncedSearchTerm, debounce, searchTerm]);

  return (
    <div className="base-search-container">
      <SearchBar styleType={styleType} onChange={setSearchTerm} placeholder={placeholder} />
      {!debounce && (
        <div className="submit-btn-container">
          <Button size="large" label="Search" onClick={() => onSearch(searchTerm)} />
        </div>
      )}
    </div>
  );
};

Search.propTypes = {
  debounce: PropTypes.bool,
  onSearch: PropTypes.func,
  placeholder: PropTypes.string,
  styleType: PropTypes.string,
};

Search.defaultProps = {
  debounce: false,
  onSearch: () => {},
  placeholder: '',
  styleType: 'default',
};

export default Search;
